/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
'use strict';
const AddClassToRadio = {

	$domSelector: $('.gfield_radio input[type=radio]'),
	$domPhoneID: $('.contact_choice>.ginput_container_radio>.gfield_radio>.gchoice:nth-child(1)>.gfield-choice-input'),
	$domEmailID: $('.contact_choice>.ginput_container_radio>.gfield_radio>.gchoice:nth-child(2)>.gfield-choice-input'),
	$domRadio: $('.gfield-choice-input'),
	$domBtnContainer: '.gchoice',
	classChangeIcon: 'selected-contact',
	classChangeColors: 'selected',

	init: function() {
		this.changeIcon();
		this.changeStyleClass();
	},

	changeIcon: function() {
		if(AddClassToRadio.$domPhoneID.is(':checked') || AddClassToRadio.$domEmailID.is(':checked')){
			AddClassToRadio.$domRadio.closest(AddClassToRadio.$domBtnContainer).removeClass(AddClassToRadio.classChangeIcon);
			$('.gfield-choice-input:checked').closest(AddClassToRadio.$domBtnContainer).addClass(AddClassToRadio.classChangeIcon);
		}
		AddClassToRadio.$domSelector.on('change', function() {
			if (AddClassToRadio.$domPhoneID.is(':checked')) {
				AddClassToRadio.$domRadio.closest(AddClassToRadio.$domBtnContainer).removeClass(AddClassToRadio.classChangeIcon);
				AddClassToRadio.$domPhoneID.closest(AddClassToRadio.$domBtnContainer).addClass(AddClassToRadio.classChangeIcon);

			} else if (AddClassToRadio.$domEmailID.is(':checked')) {
				AddClassToRadio.$domRadio.closest(AddClassToRadio.$domBtnContainer).removeClass(AddClassToRadio.classChangeIcon);
				AddClassToRadio.$domEmailID.closest(AddClassToRadio.$domBtnContainer).addClass(AddClassToRadio.classChangeIcon);

			}
		});
	},

	changeStyleClass: function() {

		if(AddClassToRadio.$domRadio.is(':checked')){
			AddClassToRadio.$domRadio.closest(AddClassToRadio.$domBtnContainer).removeClass(AddClassToRadio.classChangeColors);
			$('.gfield-choice-input:checked').closest(AddClassToRadio.$domBtnContainer).addClass(AddClassToRadio.classChangeColors);
		}
		AddClassToRadio.$domSelector.on('change', function() {

			if (AddClassToRadio.$domRadio.is(':checked')) {
				AddClassToRadio.$domRadio.closest(AddClassToRadio.$domBtnContainer).removeClass(AddClassToRadio.classChangeColors);
				$('.gfield-choice-input:checked').closest(AddClassToRadio.$domBtnContainer).addClass(AddClassToRadio.classChangeColors);
				return;
			}

			AddClassToRadio.$domRadio.closest(AddClassToRadio.$domBtnContainer).removeClass(AddClassToRadio.classChangeColors);
		});
	}
};

export default AddClassToRadio;